import React, {
 useState, useEffect, useContext, useRef,
} from 'react';
import { CSSTransition } from 'react-transition-group';
import { ShouldGoFullscreenScroll, PreventScroll } from '@/components/utils/DeviceUtils';
import Text from '@/components/atoms/Text';
import './FullscreenOverlayScroll.scss';
import { StateContext } from '@/state/store';

const MINIMUM_SCROLL = 200;
const LARGE_SCREEN_THRESHOLD = 600;

const FULLSCREEN_HEIGHT = {
    large: 370,
    small: 300,
};

let visible = false;

// All kinds of sorcery to get content to be displayed unified across
// different iphone versions. Especially if overlay was displayed a second time.
const resetCss = (refContent, refLine) => {
    if (!refLine) return;
    setTimeout(() => {
        // eslint-disable-next-line no-param-reassign
        refContent.style.height = `${window.innerHeight}px`;
        // eslint-disable-next-line no-param-reassign
        refContent.style.maxHeight = `${window.innerHeight}px`;

        refContent.classList.add('FullscreenOverlayScroll__content__visible');
    }, 61);

    setTimeout(() => {
        refLine.classList.remove('FullscreenOverlayScroll__content__scrolling-indicator-line-start');
        refLine.classList.add('FullscreenOverlayScroll__content__scrolling-indicator-line-start');
    }, 100);
};

const setVisibilityState = (visibilityState, setOverlayState, dispatch, refContent, refLine) => {
    if (visibilityState) {
        setOverlayState(true);
        PreventScroll(false);
        dispatch({ type: 'SHOW_FULLSCREEN_OVERLAY_SCROLL' });
        resetCss(refContent.current, refLine.current);
        window.scrollTo(0, 0);
        visible = true;
    } else {
        dispatch({ type: 'HIDE_FULLSCREEN_OVERLAY_SCROLL' });
        setOverlayState(false);
        PreventScroll(true);
        visible = false;
    }
};

function init(setOverlayState, dispatch, refContent, refLine) {
    if (!ShouldGoFullscreenScroll()) return null;

    // eslint-disable-next-line no-restricted-globals
    const compareHeight = screen.height < LARGE_SCREEN_THRESHOLD ? FULLSCREEN_HEIGHT.small : FULLSCREEN_HEIGHT.large;

    // maybe overdoing it here with all these checks,
    // but when hacking around it did seem to help at edge cases.
    // Could perhaps simplify things, but aint nobody got time for that
    let scrollLockPos = 0;
    let scrollLockInitiated = false;

    window.addEventListener('scroll', () => {
        const scrollPos = document.documentElement.scrollTop || document.body.scrollTop;

        if (window.innerHeight >= compareHeight && scrollPos > MINIMUM_SCROLL && !scrollLockInitiated) {
            PreventScroll(true);
            scrollLockInitiated = true;

            scrollLockPos = scrollPos;
            setTimeout(() => {
                if (scrollLockPos >= scrollPos) {
                    setVisibilityState(false, setOverlayState, dispatch, refContent, refLine);
                } else {
                    PreventScroll(false);
                    scrollLockInitiated = false;
                }
            }, 500);
        }
    });

    // constantly check if address bar is visible. onResize was not reliable
    const interval = setInterval(() => {
        if (window.innerHeight <= compareHeight) {
            PreventScroll(false);
            if (!visible) {
                setVisibilityState(true, setOverlayState, dispatch, refContent, refLine);
            }
            scrollLockInitiated = false;
        }
    }, 300);

    // On initial screen load
    setTimeout(() => {
        if (window.innerHeight <= compareHeight) {
            setVisibilityState(true, setOverlayState, dispatch, refContent, refLine);
        } else {
            PreventScroll(true);
        }
    }, 130);

    return interval;
}

export default ({ data }) => {
    const [overlayState, setOverlayState] = useState(false);
    const refContent = useRef();
    const refLine = useRef();

    const store = useContext(StateContext);
    const { dispatch } = store;

    useEffect(() => {
        visible = false;
        const interval = init(setOverlayState, dispatch, refContent, refLine);
        return () => {
            if (interval) clearInterval(interval);
        };
    }, []);

    return (
        <>
            {ShouldGoFullscreenScroll() && overlayState ? (
                <>
                    <div className="FullscreenOverlayScroll" />
                    <div className="FullscreenOverlayScroll__background" />
                    <div className="FullscreenOverlayScroll__content" ref={refContent}>
                        <div className="FullscreenOverlayScroll__content__inner">
                            <div className="FullscreenOverlayScroll__content__heading">
                                <Text className="h4">{data.body}</Text>
                            </div>
                            <div className="FullscreenOverlayScroll__content__icon">
                                <CSSTransition in timeout={1000}>
                                    <div className="FullscreenOverlayScroll__content__scrolling-indicator-line" ref={refLine} />
                                </CSSTransition>
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                ''
            )}
        </>
    );
};
